<template>
  <div
    @focus="handleFocus"
    @focusout="handleFocusOut"
    tabindex="0"
    ref="frame"
    class="popup-wrapper">
    <div class="flex flex-col popup-background" tabindex="1">
      <div class="send-reminder-cont">
        <p>Yeni <strong>Kullanıcı</strong> eklemek için formu doldurum ve Onayla tuşuna basın. </p>
      </div>
      <div class="flex flex-col">
        <div class="regular-input-field">
          <input class="w-full regular-input"
                 type="email"
                 v-model="email"
                 placeholder="Email"
                 data-vv-name="Email"
                 v-validate="'required'">
          <span class="text-danger text-sm" v-show="errors.has('Email')">{{ showError('Email') }}</span>
        </div>

        <div class="regular-input-field" v-if="!user">
          <input class="w-full regular-input"
                 type="password"
                 v-model="password"
                 placeholder="Parola"
                 data-vv-name="Parola"
                 v-validate="'required'">
          <span class="text-danger text-sm" v-show="errors.has('Parola')">{{ showError('Parola') }}</span>
        </div>
        <div class="regular-input-field">
          <input class="w-full regular-input"
                 type="text"
                 v-model="username"
                 placeholder="Kullanici Adi"
                 data-vv-name="Kullanici Adi"
                 v-validate="'required'">
          <span class="text-danger text-sm" v-show="errors.has('Kullanici Adi')">{{ showError('Kullanici Adi') }}</span>
        </div>
        <div class="regular-input-field" v-if="show_phone">
          <phone-mask-input
            v-model="phone"
            autoDetectCountry
            showFlag
            @onValidate="onValidate"
            wrapperClass="relative"
            inputClass="cart-input w-full"
            flagClass="phone-flag"
          />
          <span class="text-danger text-sm" v-show="errors.has('Telefon Numarasi')">{{ showError('Telefon Numarasi') }}</span>
        </div>

        <div class="regular-input-field">
          <select
            class="selectExample w-full text-white"
            label="Kullanıcı Rolü"
            v-model="role"
          >
            <option :key="index" :value="item.value" v-for="(item, index) in user_roles">{{item.label}}</option>
          </select>
        </div>
        <div class="regular-input-field">
          <multiselect name="Restaurants" v-validate="'required'" v-model="selected"
                       label="label" track-by="label" :multiple="true"
                       :options="bolge_options"></multiselect>
        </div>
      </div>
      <div class="w-full mt-4">
        <div class="popup-button blue-button" @click="confirm">Onayla</div>
        <div class="popup-button black-button" @click="cancel">Vazgeç</div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import PhoneMaskInput from  'vue-phone-mask-input'

export default {
  props: {
    updated: {
      type: Function
    },
    cancelled: {
      type: Function
    },
    user: {
      type: Object
    }
  },
  components: {
    Multiselect,
    PhoneMaskInput
  },
  name: 'UserPopup',
  mounted () {
    if (this.bolge_data.length === 0) {
      this.getBolgeList()
    }
    if (this.user) {
      this.loadData()
    } else {
      this.show_phone = true
    }
    console.log('active user', this.activeUserInfo)
  },
  data () {
    return {
      email: '',
      password: '',
      username: '',
      phone: '+90',
      show_phone: false,
      bolgeler: [],
      user_roles: [
        {
          label: 'Kullanici',
          value: 'user'
        },
        {
          label: 'Yönetici',
          value: 'admin'
        },
        {
          label: 'Genel Yönetici',
          value: 'superadmin'
        }
      ],
      role: 'user',
      selected: null,
      options: ['list', 'of', 'options']
    }
  },
  watch: {
    selected () {
      console.log('selected bolges', this.selected)
    },
    phone (val) {
      console.log('phone val', val)
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    bolge_data () {
      return this.$store.state.bolge_data
    },
    bolge_options () {
      const options_array = []

      this.bolge_data.map(bolge => {
        const option = {
          label: bolge.name,
          value: bolge.id
        }
        options_array.push(option)
      })
      return options_array
    },
    bolge_list_for_save () {
      const result = []
      this.selected.map(bolge_id => {
        result.push(bolge_id.value)
      })
      return result
    }
  },
  methods: {

    onValidate (data) {
      console.log(data, this.phone)
      //this.phone = data
    },
    showError (tag) {
      return `${tag} alanı boş bırakılamaz`
    },
    handleFocus () {
      // do something here
      console.log('in')
      this.cancel()
    },
    handleFocusOut () {
      // do something here
      console.log('out')
    },
    resetData () {
      this.email = ''
      this.password = ''
      this.username = ''
      this.phone = ''
      this.bolgeler = []
      this.role = 'user'
    },
    loadData () {
      const { email, password, username, role, phone, bolgeler } = JSON.parse(JSON.stringify(this.user))
      const bolge_list = JSON.parse(bolgeler)
      this.email = email
      this.password = password
      this.username = username
      this.phone = phone
      this.role = role
      if (bolge_list) {
        this.selected = this.bolge_options.filter(bolge => bolge_list.includes(bolge.value))
      }
      console.log('load data', { phone: this.phone, bolgeler: this.selected })
      this.show_phone = true
    },

    getBolgeList () {
      const payload = {
        page: 1,
        items: 20
      }

      this.$store.dispatch('getBolgeList', payload)
        .then((response) => {
          console.log('bolge list', response)
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          console.log('error', error)
        })
    },
    addUser (payload) {
      this.$store.dispatch('addUser', payload)
        .then((response) => {
          console.log('add user', response)
          this.$vs.loading.close()
          this.updated(response)
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
        })
    },
    editUser (payload) {
      this.$store.dispatch('editUser', payload)
        .then((response) => {
          console.log('editUser', response)
          this.$vs.loading.close()
          this.updated(response)
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
        })
    },
    confirm () {
      return new Promise(() => {
        this.$validator.validateAll().then(result => {
          if (result) {
            const payload = {
              email: this.email,
              username: this.username,
              role: this.role,
              phone: this.phone,
              bolgeler: JSON.stringify(this.bolge_list_for_save),
              parent_id: this.activeUserInfo.id
            }
            if (this.user) {
              payload.id = this.user.id
              this.editUser(payload)
            } else {
              payload.password = this.password
              this.addUser(payload)
            }
          } else {
            this.$vs.notify({
              title: 'Hata',
              text: 'Lütfen gerekli alanları doldurun',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
          }
        })
      })
    },
    cancel () {
      this.resetData()
      this.cancelled()
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">

.selectExample {
  color: white;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%
  }
}
</style>
